// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_cbU","cls2":"SimplePaperPodcast-cls2__1g SimplePaperPodcast-cls1_cbU"};